module.exports = __webpack_public_path__ + "static/media/1.391dc9d5.jpg";